import React from 'react'
import {
  CheckboxContainer,
  HiddenCheckbox,
  StyledCheckbox,
  CheckIcon
} from './styles'

const FormCheck = ({ value, allowEdit, fn, className }) => {
  return (
    <div className={`checkbox disabled ${className ? className : ''}`}>
      <CheckboxContainer>
        <HiddenCheckbox checked={value} readOnly />
        <StyledCheckbox
          checked={value}
          onClick={allowEdit ? fn : null}
          disable={allowEdit ? false : true}
        >
          <CheckIcon viewBox="0 4 24 24">
            <polyline points="20 6 9 17 4 12" />
          </CheckIcon>
        </StyledCheckbox>
      </CheckboxContainer>
    </div>
  )
}

export default FormCheck
